export default 'https://tme.understood.org/assets/global_outro.en.49049cb5.vtt'